import './assets/styles/base.css';
import 'regenerator-runtime/runtime'

import Vue from "vue";
import App from "./ProForm";
import store from "./store";

import axios from "axios";
import VueAxios from "vue-axios";

Vue.config.productionTip = false;

Vue.use(VueAxios, axios);

let googleMapsScript = document.createElement("script");
googleMapsScript.setAttribute(
  "src",
  "https://maps.googleapis.com/maps/api/js?client=gme-veluxas1&channel=v-as.mapsearch&libraries=geometry,places"
);
document.head.appendChild(googleMapsScript);

const id = "vue-app-pro-form";
if (document.getElementById(id)) {
    new Vue({
        store,
        render: h => h(App)
    }).$mount("#" + id);
}

